import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home/home";
import Related from "../pages/products/CategoryCard";
import RelatedDetails from "../pages/products/CategoryDetails";
import Form from "../pages/forms/Forms"
import ContactForm from "../pages/Home/Contact"
import MyAds from "../pages/user/MyAds";
import Dashboard from "../pages/Admin/Dashboard";

function Routers() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/related" element={<Related />} />
      <Route path="/relateddetails" element={<RelatedDetails />} />
      <Route path="/add-post" element={<Form />} />
      <Route path="/contact" element={<ContactForm />} />
      <Route path="/myads" element={<MyAds />} />
      <Route path="/admin" element={<Dashboard />} />
    </Routes>
  );
}

export default Routers;

 